import React from 'react';
import { useIntl } from 'react-intl';
import { withFormsy } from 'formsy-react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { styled } from '@mui/system';

import { type DateRangeType, type FilterItemBaseProps } from '../FilterItemManager';
import Icon from '../../Icon';
import DateRangeFilterDialog from '../components/DateRangeFilterDialog';

const StyledTextField = styled(TextField)(({ theme }) => ({
	'& > .MuiOutlinedInput-root': {
		paddingRight: 0,
		'& > .MuiOutlinedInput-input': {
			paddingTop: 12,
			paddingBottom: 12
		}
	}
}));

function DateRangeFilterItem(props: FilterItemBaseProps<DateRangeType>) {
	const intl = useIntl();

	const isDisabled = !!props.defaultValue;

	const dateRange = props.defaultValue
		? { from: props.defaultValue?.from, to: props.defaultValue?.to }
		: { from: props.value?.from, to: props.value?.to };

	const [dialogOpen, setDialogOpen] = React.useState(false);

	const formattedDateFrom = intl.formatDate(dateRange.from, { year: 'numeric', month: '2-digit', day: '2-digit' });
	const formattedDateTo = intl.formatDate(dateRange.to, { year: 'numeric', month: '2-digit', day: '2-digit' });

	const displayDate = `${formattedDateFrom} 🠖 ${formattedDateTo}`;

	return (
		<>
			<StyledTextField
				className={props.className}
				name={props.name}
				variant="outlined"
				size="small"
				fullWidth
				autoComplete="off"
				slotProps={{
					inputLabel: { shrink: true },
					input: {
						readOnly: true,
						endAdornment: !isDisabled && (
							<InputAdornment position="end">
								<IconButton size="small" onClick={() => setDialogOpen(true)}>
									<Icon icon="calendar" />
								</IconButton>
							</InputAdornment>
						)
					}
				}}
				placeholder={props.placeholder || 'dd/mm/yyyy 🠖 dd/mm/yyyy'}
				value={dateRange.from && dateRange.to ? displayDate : ''}
				disabled={isDisabled}
			/>
			<DateRangeFilterDialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				dateRange={dateRange}
				sendChange={newValue => props.sendChange(newValue)}
			/>
		</>
	);
}

export default React.memo(withFormsy(DateRangeFilterItem));
